module.exports = __webpack_public_path__ + "media/src/images/partners/whu-dff29c5cbd24d6ca145b74e8073e4f92.jpg";